import {
  forwardRef,
  useTagStyles,
  type TagLabelProps as ChakraTagLabelProps,
} from '@chakra-ui/react';
import { chakra } from '@chakra-ui/system';
import { cx } from '@chakra-ui/utils';

export type TagLabelProps = ChakraTagLabelProps;

export const TagLabel = forwardRef<TagLabelProps, 'span'>(
  ({ className, ...restProps }, ref) => {
    const styles = useTagStyles();
    return (
      <chakra.span
        className={cx('tag__label', className)}
        __css={styles.label}
        {...restProps}
        ref={ref}
        data-action-type="default"
      />
    );
  },
);
